import { Facebook, Linkedin, Twitter, Youtube } from "lucide-react";
import { CONTACT, NAV_LINKS } from "../../data/content";
import { Logo } from "./Logo";

const SUPPORT_LINKS = [
  { label: "Contact Us", href: "#contact", scroll: true },
  { label: "Careers", href: "#", scroll: false },
  { label: "Disclaimer", href: "#", scroll: false },
  { label: "Privacy Policy", href: "#", scroll: false },
  { label: "Terms of Services", href: "#", scroll: false },
];

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "#" },
  { icon: Linkedin, label: "LinkedIn", href: "#" },
  { icon: Twitter, label: "Twitter", href: "#" },
  { icon: Youtube, label: "YouTube", href: "#" },
];

export const Footer = () => {
  const go = (e, href) => {
    e.preventDefault();
    window.__lenis?.scrollTo(href, { offset: -76, duration: 1.4 });
  };

  return (
    <footer data-testid="site-footer" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <p className="font-display font-bold tracking-tight text-lg text-navy mb-6">SUPPORT</p>
          <ul className="space-y-3">
            {SUPPORT_LINKS.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={l.scroll ? (e) => go(e, l.href) : undefined}
                  className="text-sm text-subtle hover:text-brand transition-colors duration-300"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-display font-bold tracking-tight text-lg text-navy mb-6">
            VR VISION PROJECTS<br />& ENGINEERING SERVICES
          </p>
          <ul className="space-y-2 text-sm text-subtle leading-relaxed">
            <li>{CONTACT.address}</li>
            <li className="pt-2">Phone: {CONTACT.phone}, {CONTACT.phone2}</li>
            <li className="break-all">{CONTACT.email}</li>
            <li className="break-all">{CONTACT.email2}</li>
            <li>{CONTACT.website}</li>
          </ul>
        </div>

        <div className="flex flex-col items-start md:items-end gap-6">
          <Logo markClass="h-14 w-auto" textSize="text-xl" />
          <div>
            <p className="font-display font-bold tracking-tight text-sm text-navy mb-4 md:text-right">FOLLOW US ON:</p>
            <div className="flex items-center gap-4">
              {SOCIALS.map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  aria-label={label}
                  className="w-10 h-10 flex items-center justify-center bg-navy text-white hover:bg-brand transition-colors duration-300"
                >
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-navy py-4">
        <p className="text-center text-xs text-white/80">
          © {new Date().getFullYear()} VR Vision Projects & Engineering Services. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};
